(function () {
  'use strict';

  window.__c27Support = window.__c27Support || {};

  var NS = 'pdp';
  var bootKey = NS + 'Bootstrapped';
  var controllers = typeof WeakMap !== 'undefined' ? new WeakMap() : null;
  var fallbackMap = new Map();
  var NAV_IDS = ['first-set-up', 'tutorials', 'manuals-downloads', 'faq', 'product-information'];
  var DEFAULT_PANEL = 'first-set-up';
  var PANEL_ENTER_MS = 250;
  var SPACING_VARS = [
    '--c27-support-pdp-pt-desktop',
    '--c27-support-pdp-pt-mobile',
    '--c27-support-pdp-pb-desktop',
    '--c27-support-pdp-pb-mobile',
  ];
  var pdpViewportMount = null;

  function controllerMap() {
    return controllers || fallbackMap;
  }

  function collectRoots(container) {
    if (!container) return [];
    var roots = [];
    if (container.matches && container.matches('[data-c27-support-component]')) {
      roots.push(container);
    }
    roots.push.apply(
      roots,
      Array.prototype.slice.call(container.querySelectorAll('[data-c27-support-component]'))
    );
    return roots;
  }

  function measureHeaderOffset() {
    var navBar = document.querySelector('.c27-nav .c27-nav__bar');
    if (navBar && isElementVisible(navBar)) {
      return navBar.getBoundingClientRect().height;
    }
    var header =
      document.querySelector('.shopify-section-header-sticky') ||
      document.querySelector('header') ||
      document.querySelector('[id*="header"]');
    if (!header) return null;
    return header.getBoundingClientRect().height;
  }

  function getFooterElement() {
    return (
      document.querySelector('.shopify-section-group-footer-group footer') ||
      document.querySelector('.c27-footer-section') ||
      document.querySelector('.shopify-section-group-footer-group') ||
      document.querySelector('footer') ||
      document.querySelector('[id*="footer" i]')
    );
  }

  function measureFooterHeight() {
    var footer = getFooterElement();
    if (!footer || !isElementVisible(footer)) return 0;
    return footer.getBoundingClientRect().height;
  }

  var mobileChromeRaf = 0;
  var mobileChromeLastWidth = 0;
  var mobileChromeScrollIdleTimer = 0;

  function setMobileChromeScrolling(isScrolling) {
    if (!window.matchMedia('(max-width: 1199px)').matches) return;
    if (document.documentElement.classList.contains('c27-support-pdp-sheet-open')) return;

    var chrome = document.querySelector('[data-c27-support-pdp-mobile-chrome]');
    if (!chrome) return;
    chrome.classList.toggle('is-scrolling', isScrolling);
  }

  function handleMobileChromeScroll() {
    if (!window.matchMedia('(max-width: 1199px)').matches) return;
    if (!document.documentElement.classList.contains('c27-support-pdp-is-active')) return;

    setMobileChromeScrolling(true);
    if (mobileChromeScrollIdleTimer) window.clearTimeout(mobileChromeScrollIdleTimer);
    mobileChromeScrollIdleTimer = window.setTimeout(function () {
      mobileChromeScrollIdleTimer = 0;
      setMobileChromeScrolling(false);
    }, 180);
  }

  function clearMobileChromeScrollState() {
    if (mobileChromeScrollIdleTimer) {
      window.clearTimeout(mobileChromeScrollIdleTimer);
      mobileChromeScrollIdleTimer = 0;
    }
    var chrome = document.querySelector('[data-c27-support-pdp-mobile-chrome]');
    if (chrome) chrome.classList.remove('is-scrolling');
  }

  function clearMobileChromePosition() {
    var bar = document.querySelector('.c27-support-pdp-mobile-chrome__bar');
    if (bar) {
      bar.style.removeProperty('transform');
      bar.style.removeProperty('visibility');
      bar.style.removeProperty('bottom');
      bar.style.removeProperty('top');
    }
    if (mobileChromeRaf) {
      window.cancelAnimationFrame(mobileChromeRaf);
      mobileChromeRaf = 0;
    }
    document.documentElement.style.removeProperty('--c27-support-pdp-mobile-chrome-offset');
    clearMobileChromeScrollState();
  }

  function setMobileChromeOffset(heightPx) {
    var next = Math.ceil(heightPx) || 88;
    var current =
      parseFloat(
        getComputedStyle(document.documentElement).getPropertyValue(
          '--c27-support-pdp-mobile-chrome-offset'
        )
      ) || 0;
    if (Math.abs(current - next) < 1) return;
    document.documentElement.style.setProperty(
      '--c27-support-pdp-mobile-chrome-offset',
      next + 'px'
    );
  }

  /**
   * Footer 已隐藏：TOC 纯 CSS fixed bottom，不跟随 visualViewport 重算，避免 Chrome 更跳。
   */
  function syncMobileChromePosition() {
    if (!window.matchMedia('(max-width: 1199px)').matches) {
      clearMobileChromePosition();
      return;
    }

    if (!document.documentElement.classList.contains('c27-support-pdp-is-active')) return;

    var bar = document.querySelector('.c27-support-pdp-mobile-chrome__bar');
    if (!bar) return;

    bar.style.removeProperty('top');
    bar.style.removeProperty('bottom');
    bar.style.removeProperty('transform');
    if (bar.style.visibility === 'hidden') bar.style.visibility = '';
    setMobileChromeOffset(bar.offsetHeight || 88);
  }

  function isElementVisible(element) {
    if (!element) return false;
    var style = window.getComputedStyle(element);
    if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') {
      return false;
    }
    var rect = element.getBoundingClientRect();
    return rect.height > 0 && rect.width > 0;
  }

  function getHeroSpacingSource() {
    return (
      document.querySelector('[data-c27-support-pdp-layout-root]') ||
      document.querySelector('.c27-support-pdp-hero-section')
    );
  }

  function readSpacingVar(source, name) {
    if (!source) return '';

    var inlineValue = source.style.getPropertyValue(name);
    if (inlineValue && inlineValue.trim()) return inlineValue.trim();

    var computedValue = window.getComputedStyle(source).getPropertyValue(name);
    return computedValue ? computedValue.trim() : '';
  }

  function applySpacingVars(target) {
    var source = getHeroSpacingSource();
    if (!source || !target) return;

    SPACING_VARS.forEach(function (name) {
      var value = readSpacingVar(source, name);
      if (value) target.style.setProperty(name, value);
    });

    var isDesktop = window.matchMedia('(min-width: 1200px)').matches;
    var pt = readSpacingVar(
      source,
      isDesktop ? '--c27-support-pdp-pt-desktop' : '--c27-support-pdp-pt-mobile'
    );
    var pb = readSpacingVar(
      source,
      isDesktop ? '--c27-support-pdp-pb-desktop' : '--c27-support-pdp-pb-mobile'
    );

    if (pt) target.style.setProperty('--c27-support-pdp-pt-current', pt);
    if (pb) target.style.setProperty('--c27-support-pdp-pb-current', pb);
  }

  function syncSpacingVars() {
    applySpacingVars(document.documentElement);

    if (pdpViewportMount && pdpViewportMount.viewport) {
      applySpacingVars(pdpViewportMount.viewport);
    }
  }

  function initHeroImageFade() {
    var image = document.querySelector('.c27-support-pdp-viewport .c27-support-pdp-hero__image');
    if (!image) return;

    function markLoaded() {
      image.classList.add('is-loaded');
      syncRotatingHeroLayout();
    }

    if (image.complete && image.naturalWidth > 0) {
      markLoaded();
      return;
    }

    image.addEventListener('load', markLoaded, { once: true });
  }

  function finishRouteFadeIfReady() {
    if (window.__c27Support.routeFade && window.__c27Support.routeFade.finish) {
      window.__c27Support.routeFade.finish();
    }
  }

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function updateViewportMetrics() {
    syncSpacingVars();

    var layoutRoot = document.querySelector('[data-c27-support-pdp-layout-root]');
    if (layoutRoot) {
      var productKey = layoutRoot.getAttribute('data-product-key') || 'companion-hub';
      document.documentElement.setAttribute('data-c27-support-pdp-product', productKey);
    }

    var headerH = measureHeaderOffset() || 120;
    var footerH = measureFooterHeight();
    var isMobile = window.matchMedia('(max-width: 1199px)').matches;
    /* 移动端主区用 100svh，勿把 innerHeight-footer 写回变量触发布局抖动 */
    var viewportH = isMobile
      ? Math.max(560, window.innerHeight)
      : Math.max(560, window.innerHeight - headerH - footerH);

    document.documentElement.style.setProperty('--c27-support-pdp-header-offset', headerH + 'px');
    document.documentElement.style.setProperty('--c27-support-pdp-footer-offset', footerH + 'px');
    document.documentElement.style.setProperty('--c27-support-pdp-viewport-h', viewportH + 'px');
    syncSideNavFixedLayout({ updatePosition: true });
  }

  function clearPageMinHeight() {
    document.documentElement.style.removeProperty('--c27-support-pdp-page-min-h');
  }

  function measurePanelInnerHeight(panel, stageWidth) {
    var inner = panel.querySelector('.c27-support-pdp-panel-inner');
    if (!inner) return 0;

    var saved = {
      panelDisplay: panel.style.display,
      panelPosition: panel.style.position,
      panelVisibility: panel.style.visibility,
      panelPointerEvents: panel.style.pointerEvents,
      panelWidth: panel.style.width,
      panelLeft: panel.style.left,
      panelTop: panel.style.top,
    };

    panel.style.display = 'block';
    panel.style.position = 'absolute';
    panel.style.visibility = 'hidden';
    panel.style.pointerEvents = 'none';
    panel.style.width = stageWidth + 'px';
    panel.style.left = '0';
    panel.style.top = '0';

    var height = inner.getBoundingClientRect().height;

    panel.style.display = saved.panelDisplay;
    panel.style.position = saved.panelPosition;
    panel.style.visibility = saved.panelVisibility;
    panel.style.pointerEvents = saved.panelPointerEvents;
    panel.style.width = saved.panelWidth;
    panel.style.left = saved.panelLeft;
    panel.style.top = saved.panelTop;

    return Math.ceil(height);
  }

  function syncPageMinHeight(panels, activePanelId) {
    if (!panels || !panels.length) return;

    if (!window.matchMedia('(min-width: 1200px)').matches) {
      clearPageMinHeight();
      return;
    }

    var activePanel = null;
    if (activePanelId) {
      for (var i = 0; i < panels.length; i += 1) {
        if (panels[i].getAttribute('data-c27-support-pdp-panel') === activePanelId) {
          activePanel = panels[i];
          break;
        }
      }
    }
    if (!activePanel) {
      for (var j = 0; j < panels.length; j += 1) {
        if (panels[j].classList.contains('is-active')) {
          activePanel = panels[j];
          break;
        }
      }
    }
    if (!activePanel) activePanel = panels[0];

    var contentStage = document.querySelector('.c27-support-pdp-content-stage');
    var stageWidth = contentStage ? contentStage.getBoundingClientRect().width : 0;
    if (stageWidth <= 0) stageWidth = 800;

    var panelHeight = 0;
    if (activePanel.classList.contains('is-active')) {
      var inner = activePanel.querySelector('.c27-support-pdp-panel-inner');
      if (inner) panelHeight = Math.ceil(inner.getBoundingClientRect().height);
    } else {
      panelHeight = measurePanelInnerHeight(activePanel, stageWidth);
    }

    if (panelHeight <= 0) return;

    var bodyShell = document.querySelector('.c27-support-pdp-body-shell');
    var shellStyle = bodyShell ? getComputedStyle(bodyShell) : null;
    var shellPadding = shellStyle
      ? (parseFloat(shellStyle.paddingTop) || 0) + (parseFloat(shellStyle.paddingBottom) || 0)
      : 0;
    var pageMin = panelHeight + shellPadding;

    document.documentElement.style.setProperty('--c27-support-pdp-page-min-h', Math.ceil(pageMin) + 'px');
  }

  function clamp01(value) {
    return Math.max(0, Math.min(1, value));
  }

  function computeSideNavHideProgress(shellRect, fixedTop, navFixed) {
    var progress = 0;
    var innerHeight = window.innerHeight;
    var navHeight = navFixed.offsetHeight || 0;
    var navBottom = fixedTop + navHeight;
    var fadeSpan = Math.max(180, innerHeight * 0.22);

    if (shellRect) {
      var shellFadeEnd = fixedTop + 16;
      var shellFadeStart = shellFadeEnd + fadeSpan;
      if (shellRect.bottom < shellFadeStart) {
        progress = Math.max(progress, clamp01((shellFadeStart - shellRect.bottom) / fadeSpan));
      }
    }

    var viewport = document.querySelector('.c27-support-pdp-viewport');
    if (viewport) {
      var viewportRect = viewport.getBoundingClientRect();
      var viewportFadeEnd = navBottom + 16;
      var viewportFadeStart = viewportFadeEnd + fadeSpan;
      if (viewportRect.bottom < viewportFadeStart) {
        progress = Math.max(
          progress,
          clamp01((viewportFadeStart - viewportRect.bottom) / fadeSpan)
        );
      }
    }

    var footer = getFooterElement();
    if (footer) {
      var footerRect = footer.getBoundingClientRect();
      var footerFadeStart = innerHeight + fadeSpan * 0.35;
      var footerFadeEnd = navBottom + 8;
      if (footerRect.top < footerFadeStart) {
        progress = Math.max(
          progress,
          clamp01((footerFadeStart - footerRect.top) / Math.max(1, footerFadeStart - footerFadeEnd))
        );
      }
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return progress >= 0.5 ? 1 : 0;
    }

    return progress;
  }

  function clearSideNavFixedLayout() {
    var navCol = document.querySelector('.c27-support-pdp-side-nav-col');
    var navFixed = document.querySelector('[data-c27-support-pdp-nav-desktop]');

    document.documentElement.style.removeProperty('--c27-support-pdp-side-nav-fixed-top');
    document.documentElement.style.removeProperty('--c27-support-pdp-side-nav-fixed-left');

    if (navCol) navCol.style.removeProperty('min-height');
    if (navFixed) {
      navFixed.style.removeProperty('--c27-support-pdp-side-nav-visible');
      navFixed.classList.remove('is-past-viewport');
    }
  }

  function syncSideNavFixedLayout(options) {
    var opts = options || {};
    var updatePosition = opts.updatePosition !== false;
    var shell = document.querySelector('.c27-support-pdp-body-shell');
    var navCol = document.querySelector('.c27-support-pdp-side-nav-col');
    var navFixed = document.querySelector('[data-c27-support-pdp-nav-desktop]');

    if (!shell || !navCol || !navFixed) return;

    if (!window.matchMedia('(min-width: 1200px)').matches) {
      clearSideNavFixedLayout();
      return;
    }

    var shellRect = shell.getBoundingClientRect();
    var rootStyle = window.getComputedStyle(document.documentElement);
    var fixedTop =
      parseFloat(rootStyle.getPropertyValue('--c27-support-pdp-side-nav-fixed-top')) || 0;
    var fixedLeft =
      parseFloat(rootStyle.getPropertyValue('--c27-support-pdp-side-nav-fixed-left')) || 0;

    if (updatePosition) {
      var shellStyle = window.getComputedStyle(shell);
      var paddingLeft = parseFloat(shellStyle.paddingLeft) || 0;
      var paddingTop = parseFloat(shellStyle.paddingTop) || 0;
      /*
       * Use document coordinates so hash / ?item= deep links that scroll before init
       * do not pin the nav to viewport top (getBoundingClientRect().top shrinks with scroll).
       */
      var scrollX = window.pageXOffset || document.documentElement.scrollLeft || 0;
      var scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;

      fixedTop = Math.round(shellRect.top + scrollY + paddingTop);
      fixedLeft = Math.round(shellRect.left + scrollX + paddingLeft);

      document.documentElement.style.setProperty('--c27-support-pdp-side-nav-fixed-top', fixedTop + 'px');
      document.documentElement.style.setProperty('--c27-support-pdp-side-nav-fixed-left', fixedLeft + 'px');
      navCol.style.minHeight = Math.ceil(navFixed.offsetHeight) + 'px';
    }

    var hideProgress = computeSideNavHideProgress(shellRect, fixedTop, navFixed);
    var visible = 1 - hideProgress;

    navFixed.style.setProperty('--c27-support-pdp-side-nav-visible', visible.toFixed(3));
    navFixed.classList.toggle('is-past-viewport', hideProgress >= 0.98);
  }

  /**
   * Keep the content column clear of the right hero machine.
   * Important: measure .content-stage (full grid cell), not .panel-inner.
   * panel-inner is max-width 800px — bumping padding-right often leaves its
   * right edge unchanged until the stage itself shrinks below 800px.
   */
  function syncHeroContentClearance() {
    var bodyShell = document.querySelector('.c27-support-pdp-body-shell');
    if (!bodyShell) return;

    if (!window.matchMedia('(min-width: 1200px)').matches) {
      bodyShell.style.removeProperty('padding-right');
      return;
    }

    var heroLayer = document.querySelector('.c27-support-pdp-hero__layer');
    var contentStage = document.querySelector('.c27-support-pdp-content-stage');
    if (!heroLayer || !contentStage) {
      bodyShell.style.removeProperty('padding-right');
      return;
    }

    bodyShell.style.removeProperty('padding-right');

    var gap = 40;
    var contentRight = contentStage.getBoundingClientRect().right;
    var heroRect = heroLayer.getBoundingClientRect();
    var heroImage = heroLayer.querySelector('.c27-support-pdp-hero__image');
    var solidLeft = heroRect.left;
    if (heroImage) {
      var imageRect = heroImage.getBoundingClientRect();
      if (imageRect.width > 1) {
        /*
         * Companion Hub shifts the asset left via --hero-machine-inset; rect reflects
         * that transform. Clear the visible machine, not only the hero slot box.
         */
        solidLeft = Math.min(solidLeft, imageRect.left);
      }
    }
    var basePadding = parseFloat(getComputedStyle(bodyShell).paddingRight) || 64;

    if (solidLeft < contentRight + gap) {
      basePadding += contentRight + gap - solidLeft;
    }

    var pad = Math.ceil(basePadding);
    var productKey = document.documentElement.getAttribute('data-c27-support-pdp-product') || 'companion-hub';
    /* Companion Hub: ease the clearance — full image-left pad felt ~100px too wide. */
    if (productKey !== 'rotating-base') {
      pad = Math.max(48, pad - 100);
    }

    bodyShell.style.paddingRight = pad + 'px';
  }

  function syncRotatingHeroLayout() {
    syncHeroContentClearance();
  }

  function rescanViewportComponents() {
    var viewport = document.querySelector('.c27-support-pdp-viewport');
    if (!viewport) return;

    collectRoots(viewport).forEach(function (root) {
      var component = root.getAttribute('data-c27-support-component') || '';
      if (!component || component === 'pdp-layout') return;
      if (root.dataset.c27SupportInit === 'true') destroyRoot(root);
      initRoot(root);
    });
  }

  function mountPdpViewport() {
    if (pdpViewportMount) return pdpViewportMount;

    var heroHost = document.querySelector('.c27-support-pdp-hero-section');
    var navHost = document.querySelector('.c27-support-pdp-nav-section');
    if (!heroHost) return null;

    var panelSections = Array.prototype.slice.call(
      document.querySelectorAll('[data-c27-support-pdp-panel]:not([data-c27-support-pdp-panel-optional])')
    );

    var sectionHosts = [heroHost, navHost]
      .concat(
        panelSections.map(function (section) {
          return section.closest('.shopify-section');
        })
      )
      .filter(function (host, index, list) {
        return host && list.indexOf(host) === index;
      });

    var restores = [];
    var viewport = document.createElement('div');
    viewport.className = 'c27-support-pdp-viewport';

    var layoutRoot = document.querySelector('[data-c27-support-pdp-layout-root]');
    var productKey = layoutRoot ? layoutRoot.getAttribute('data-product-key') || 'companion-hub' : 'companion-hub';
    viewport.setAttribute('data-product-key', productKey);

    var heroLayer = document.querySelector('.c27-support-pdp-hero__layer');
    if (heroLayer && heroLayer.parentNode) {
      restores.push({
        node: heroLayer,
        parent: heroLayer.parentNode,
        next: heroLayer.nextSibling,
      });
      viewport.appendChild(heroLayer);
    }

    var bodyShell = document.createElement('div');
    bodyShell.className = 'c27-support-pdp-body-shell';

    var navCol = document.createElement('aside');
    navCol.className = 'c27-support-pdp-side-nav-col';

    var navDesktop = document.querySelector('[data-c27-support-pdp-nav-desktop]');
    if (navDesktop && navDesktop.parentNode) {
      restores.push({
        node: navDesktop,
        parent: navDesktop.parentNode,
        next: navDesktop.nextSibling,
      });
      navCol.appendChild(navDesktop);
    }

    var contentStage = document.createElement('div');
    contentStage.className = 'c27-support-pdp-content-stage';
    var panelWrappers = [];

    panelSections.forEach(function (section) {
      var panelId = section.getAttribute('data-c27-support-pdp-panel');
      var inner = section.querySelector('.c27-support-pdp-panel-inner');
      if (!inner || !inner.parentNode) return;

      var wrapper = document.createElement('div');
      wrapper.className = 'c27-support-pdp-panel';
      wrapper.setAttribute('data-c27-support-pdp-panel', panelId);

      restores.push({
        node: inner,
        parent: section,
        next: inner.nextSibling,
      });
      wrapper.appendChild(inner);
      contentStage.appendChild(wrapper);
      panelWrappers.push(wrapper);
    });

    bodyShell.appendChild(navCol);
    bodyShell.appendChild(contentStage);
    viewport.appendChild(bodyShell);

    var mobileChrome = document.querySelector('[data-c27-support-pdp-mobile-chrome]');
    if (mobileChrome && mobileChrome.parentNode) {
      restores.push({
        node: mobileChrome,
        parent: mobileChrome.parentNode,
        next: mobileChrome.nextSibling,
      });
      document.body.appendChild(mobileChrome);
    }

    var insertParent = heroHost.parentNode;
    if (insertParent) {
      insertParent.insertBefore(viewport, heroHost);
    }

    sectionHosts.forEach(function (host) {
      host.classList.add('c27-support-pdp-section-host');
    });

    var main = document.getElementById('MainContent');
    if (main) main.classList.add('c27-support-pdp-main');

    applySpacingVars(viewport);

    pdpViewportMount = {
      viewport: viewport,
      panelWrappers: panelWrappers,
      restores: restores,
      sectionHosts: sectionHosts,
      main: main,
    };

    return pdpViewportMount;
  }

  function unmountPdpViewport() {
    if (!pdpViewportMount) return;

    var state = pdpViewportMount;

    state.restores.forEach(function (item) {
      if (item.next) {
        item.parent.insertBefore(item.node, item.next);
      } else {
        item.parent.appendChild(item.node);
      }
    });

    if (state.viewport && state.viewport.parentNode) {
      state.viewport.parentNode.removeChild(state.viewport);
    }

    state.sectionHosts.forEach(function (host) {
      host.classList.remove('c27-support-pdp-section-host');
    });

    if (state.main) state.main.classList.remove('c27-support-pdp-main');

    pdpViewportMount = null;
  }

  function resolvePanelIdFromLocation() {
    var hash = (window.location.hash || '').replace(/^#/, '');
    if (hash && NAV_IDS.indexOf(hash) !== -1) return hash;

    try {
      var params = new URLSearchParams(window.location.search);
      if (params.get('item')) return 'faq';
    } catch (e) {
      /* ignore */
    }

    return DEFAULT_PANEL;
  }

  function createPdpLayoutController(root) {
    var layoutRoot = document.querySelector('[data-c27-support-pdp-layout-root]');
    if (!layoutRoot) {
      return {
        init: function () {},
        destroy: function () {},
        getComponent: function () {
          return 'pdp-layout';
        },
      };
    }

    var mount = null;
    var panels = [];
    var navLinks = Array.prototype.slice.call(document.querySelectorAll('[data-c27-support-nav-link]'));
    var mobileChrome = document.querySelector('[data-c27-support-pdp-mobile-chrome]');
    var sheetRoot = document.querySelector('[data-c27-support-pdp-sheet-root]');
    var sheetOpenBtns = Array.prototype.slice.call(
      document.querySelectorAll('[data-c27-support-pdp-sheet-open]')
    );
    var sheetCloseBtns = Array.prototype.slice.call(
      document.querySelectorAll('[data-c27-support-pdp-sheet-close]')
    );
    var currentPanel = DEFAULT_PANEL;
    var onNavClick = null;
    var onHashChange = null;
    var onResize = null;
    var onScroll = null;
    var onLoad = null;
    var linkHandlers = [];

    function setActiveNav(panelId) {
      navLinks.forEach(function (link) {
        var target = link.getAttribute('data-c27-support-nav-target');
        var isActive = target === panelId;
        link.classList.toggle('is-active', isActive);
        if (link.tagName === 'A') {
          link.setAttribute('aria-current', isActive ? 'page' : 'false');
        }
        if (link.classList.contains('c27-support-pdp-mobile-chrome__sheet-item')) {
          link.classList.toggle('is-active', isActive);
        }
      });
    }

    function lockManualsScroll(panelId) {
      var lock =
        panelId === 'manuals-downloads' && window.matchMedia('(max-width: 1199px)').matches;
      document.documentElement.classList.toggle('c27-support-pdp-manuals-locked', lock);
    }

    function showPanel(panelId, options) {
      var opts = options || {};
      if (NAV_IDS.indexOf(panelId) === -1) panelId = DEFAULT_PANEL;
      var previousPanel = currentPanel;
      currentPanel = panelId;

      panels.forEach(function (panel) {
        var id = panel.getAttribute('data-c27-support-pdp-panel');
        var active = id === panelId;
        panel.classList.remove('is-entering', 'is-entered');

        if (!active) {
          panel.classList.remove('is-active');
          return;
        }

        panel.classList.add('is-active');

        if (!opts.skipScrollReset) {
          window.scrollTo(0, 0);
        }

        if (!opts.skipAnimation && previousPanel !== panelId && !prefersReducedMotion()) {
          panel.classList.add('is-entering');
          window.requestAnimationFrame(function () {
            panel.classList.add('is-entered');
          });
          window.setTimeout(function () {
            panel.classList.remove('is-entering', 'is-entered');
          }, PANEL_ENTER_MS);
        }
      });

      setActiveNav(panelId);
      lockManualsScroll(panelId);
      syncMobileChromePosition();
      window.requestAnimationFrame(function () {
        syncHeroContentClearance();
        syncPageMinHeight(panels, panelId);
      });

      if (!opts.skipHash && window.location.hash !== '#' + panelId) {
        history.replaceState(null, '', '#' + panelId);
      }
    }

    function closeSheet() {
      if (sheetRoot) sheetRoot.hidden = true;
      document.documentElement.classList.remove('c27-support-pdp-sheet-open');
      document.body.style.removeProperty('overflow');
    }

    function openSheet() {
      if (sheetRoot) sheetRoot.hidden = false;
      document.documentElement.classList.add('c27-support-pdp-sheet-open');
      document.body.style.overflow = 'hidden';
      setMobileChromeScrolling(false);
      if (mobileChrome) mobileChrome.classList.remove('is-scrolling');
    }

    function handleNavActivate(event) {
      event.preventDefault();
      var link = event.currentTarget;
      var target = link.getAttribute('data-c27-support-nav-target');
      if (!target) return;
      showPanel(target);
      closeSheet();
    }

    return {
      init: function () {
        mount = mountPdpViewport();
        panels = mount && mount.panelWrappers.length
          ? mount.panelWrappers
          : Array.prototype.slice.call(
              document.querySelectorAll('[data-c27-support-pdp-panel]:not([data-c27-support-pdp-panel-optional])')
            );

        if (!panels.length) return;

        document.documentElement.classList.add('c27-support-pdp-is-active');
        if (mobileChrome) mobileChrome.hidden = false;

        updateViewportMetrics();
        showPanel(resolvePanelIdFromLocation(), {
          skipHash: true,
          skipAnimation: true,
          skipScrollReset: true,
        });
        rescanViewportComponents();
        window.requestAnimationFrame(function () {
          syncRotatingHeroLayout();
          syncPageMinHeight(panels);
          syncSideNavFixedLayout({ updatePosition: true });
          syncMobileChromePosition();
          mobileChromeLastWidth = window.innerWidth;

          var faqRoot = document.querySelector('[data-c27-support-component="pdp-faq"]');
          if (faqRoot) {
            var faqCtrl = controllerMap().get(faqRoot);
            if (faqCtrl && faqCtrl.applyDeepLink) faqCtrl.applyDeepLink();
          }
        });
        initHeroImageFade();
        finishRouteFadeIfReady();

        onNavClick = handleNavActivate;
        navLinks.forEach(function (link, index) {
          linkHandlers[index] = handleNavActivate;
          link.addEventListener('click', linkHandlers[index]);
        });

        sheetOpenBtns.forEach(function (btn) {
          btn.addEventListener('click', openSheet);
        });
        sheetCloseBtns.forEach(function (btn) {
          btn.addEventListener('click', closeSheet);
        });

        onHashChange = function () {
          showPanel(resolvePanelIdFromLocation(), { skipHash: true });
        };
        window.addEventListener('hashchange', onHashChange);

        onResize = function () {
          var width = window.innerWidth;
          var widthChanged = Math.abs(width - mobileChromeLastWidth) >= 8;
          var isDesktop = window.matchMedia('(min-width: 1200px)').matches;

          /* Chrome 地址栏收起会狂触发 resize：移动端纯高度变化直接忽略 */
          if (!widthChanged && !isDesktop) return;

          if (widthChanged) mobileChromeLastWidth = width;

          updateViewportMetrics();
          syncRotatingHeroLayout();
          syncPageMinHeight(panels);
          syncSideNavFixedLayout({ updatePosition: true });
          if (widthChanged) syncMobileChromePosition();
        };
        window.addEventListener('resize', onResize);

        onScroll = function () {
          syncSideNavFixedLayout({ updatePosition: false });
          handleMobileChromeScroll();
        };
        window.addEventListener('scroll', onScroll, { passive: true });

        onLoad = function () {
          syncRotatingHeroLayout();
          syncPageMinHeight(panels);
          syncSideNavFixedLayout({ updatePosition: true });
          syncMobileChromePosition();
        };
        window.addEventListener('load', onLoad);
      },
      destroy: function () {
        document.documentElement.classList.remove('c27-support-pdp-is-active');
        document.documentElement.classList.remove('c27-support-pdp-manuals-locked');
        document.documentElement.classList.remove('c27-support-pdp-auto-height');
        document.documentElement.classList.remove('c27-support-pdp-sheet-open');
        document.body.style.removeProperty('overflow');
        clearPageMinHeight();
        syncRotatingHeroLayout();
        clearSideNavFixedLayout();
        clearMobileChromePosition();
        if (mobileChrome) mobileChrome.hidden = true;
        closeSheet();

        navLinks.forEach(function (link, index) {
          if (linkHandlers[index]) {
            link.removeEventListener('click', linkHandlers[index]);
          }
          link.classList.remove('is-active');
        });
        linkHandlers.length = 0;

        panels.forEach(function (panel) {
          panel.classList.remove('is-active');
        });

        if (onHashChange) window.removeEventListener('hashchange', onHashChange);
        if (onResize) window.removeEventListener('resize', onResize);
        if (onScroll) window.removeEventListener('scroll', onScroll);
        if (onLoad) window.removeEventListener('load', onLoad);
        onHashChange = null;
        onResize = null;
        onScroll = null;
        onLoad = null;

        unmountPdpViewport();
        mount = null;
        panels = [];
      },
      getComponent: function () {
        return 'pdp-layout';
      },
    };
  }

  function createPdpFaqController(root) {
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-c27-support-faq-item]'));
    var triggers = [];
    var handlers = [];

    function closeAll(exceptItem) {
      items.forEach(function (item) {
        if (item === exceptItem) return;
        item.classList.remove('is-open');
        var trigger = item.querySelector('[data-c27-support-faq-trigger]');
        var panel = item.querySelector('[data-c27-support-faq-panel]');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        if (panel) panel.classList.remove('c27-support-pdp-faq__answer-panel--open');
      });
    }

    function openItem(item) {
      closeAll(item);
      item.classList.add('is-open');
      var trigger = item.querySelector('[data-c27-support-faq-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
    }

    function resolveDeepLinkId() {
      try {
        var params = new URLSearchParams(window.location.search);
        return params.get('item');
      } catch (e) {
        return null;
      }
    }

    function applyDeepLink() {
      var deepLinkId = resolveDeepLinkId();
      if (!deepLinkId) return;

      var matched = items.find(function (item) {
        return item.getAttribute('data-faq-id') === deepLinkId;
      });
      if (!matched) return;

      openItem(matched);
      window.requestAnimationFrame(function () {
        matched.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'start' });
      });
    }

    return {
      init: function () {
        items.forEach(function (item, index) {
          var trigger = item.querySelector('[data-c27-support-faq-trigger]');
          if (!trigger) return;
          triggers[index] = trigger;
          handlers[index] = function () {
            if (item.classList.contains('is-open')) {
              item.classList.remove('is-open');
              trigger.setAttribute('aria-expanded', 'false');
            } else {
              openItem(item);
            }
          };
          trigger.addEventListener('click', handlers[index]);
        });
      },
      applyDeepLink: applyDeepLink,
      destroy: function () {
        triggers.forEach(function (trigger, index) {
          if (trigger && handlers[index]) {
            trigger.removeEventListener('click', handlers[index]);
          }
        });
        items.forEach(function (item) {
          item.classList.remove('is-open');
        });
        triggers.length = 0;
        handlers.length = 0;
      },
      getComponent: function () {
        return 'pdp-faq';
      },
    };
  }

  function createPdpManualsController(root) {
    var searchInput = root.querySelector('[data-c27-support-manuals-search]');
    var clearBtn = root.querySelector('[data-c27-support-manuals-search-clear]');
    var emptyState = root.querySelector('[data-c27-support-manuals-empty]');
    var onInput = null;
    var onClear = null;

    function getListItems() {
      return Array.prototype.slice.call(root.querySelectorAll('.c27-support-pdp-manuals__list-item'));
    }

    function filterList(query) {
      var normalized = (query || '').trim().toLowerCase();
      var visibleCount = 0;
      var listItems = getListItems();

      listItems.forEach(function (item) {
        var article = item.querySelector('[data-c27-support-manual-item]');
        var text = article ? article.getAttribute('data-search-text') || '' : '';
        var visible = !normalized || text.indexOf(normalized) !== -1;
        item.hidden = !visible;
        if (visible) visibleCount += 1;
      });

      if (emptyState) emptyState.hidden = visibleCount > 0;
      if (clearBtn) clearBtn.hidden = !normalized;
    }

    return {
      init: function () {
        filterList('');

        if (!searchInput) return;

        onInput = function () {
          filterList(searchInput.value);
        };
        onClear = function () {
          searchInput.value = '';
          filterList('');
          searchInput.focus();
        };
        searchInput.addEventListener('input', onInput);
        if (clearBtn) clearBtn.addEventListener('click', onClear);
      },
      destroy: function () {
        if (searchInput && onInput) searchInput.removeEventListener('input', onInput);
        if (clearBtn && onClear) clearBtn.removeEventListener('click', onClear);
        onInput = null;
        onClear = null;
        getListItems().forEach(function (item) {
          item.hidden = false;
        });
        if (emptyState) emptyState.hidden = true;
        if (clearBtn) clearBtn.hidden = true;
      },
      getComponent: function () {
        return 'pdp-manuals';
      },
    };
  }

  function buildSupportVideoEmbed(url) {
    try {
      var u = String(url || '').trim();
      var ytMatch = u.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([\w-]{6,})/);
      if (ytMatch) {
        return {
          type: 'iframe',
          src: 'https://www.youtube.com/embed/' + ytMatch[1] + '?autoplay=1&rel=0',
        };
      }
      var vmMatch = u.match(/vimeo\.com\/(?:video\/)?(\d+)/);
      if (vmMatch) {
        return {
          type: 'iframe',
          src: 'https://player.vimeo.com/video/' + vmMatch[1] + '?autoplay=1',
        };
      }
      if (/\.(mp4|webm|ogg)(\?|$)/i.test(u)) {
        return { type: 'video', src: u };
      }
      return { type: 'iframe', src: u };
    } catch (err) {
      return null;
    }
  }

  function initSupportVideos(container) {
    var scope = container || document;
    var roots = Array.prototype.slice.call(scope.querySelectorAll('[data-c27-support-pdp-video]'));
    roots.forEach(function (root) {
      if (root.dataset.c27SupportVideoInit === 'true') return;
      root.dataset.c27SupportVideoInit = 'true';

      var modal = root.querySelector('[data-c27-support-pdp-video-modal]');
      var modalMedia = modal ? modal.querySelector('[data-role="modal-media"]') : null;
      var modalOverlay = modal ? modal.querySelector('[data-role="modal-overlay"]') : null;
      var modalClose = modal ? modal.querySelector('[data-role="modal-close"]') : null;
      var playBtn = root.querySelector('.c27-support-pdp-video__play');
      var lockedOverflow = '';

      function openModal(embed) {
        if (!modal || !modalMedia || !embed) return;
        var headerH = measureHeaderOffset();
        if (headerH != null) {
          document.documentElement.style.setProperty(
            '--c27-support-pdp-header-offset',
            Math.ceil(headerH) + 'px'
          );
        }
        modalMedia.innerHTML =
          embed.type === 'iframe'
            ? '<iframe src="' +
              embed.src +
              '" title="Video" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>'
            : '<video src="' + embed.src + '" autoplay controls playsinline></video>';
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        lockedOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
      }

      function closeModal() {
        if (!modal || !modal.classList.contains('is-open')) return;
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        if (modalMedia) modalMedia.innerHTML = '';
        document.body.style.overflow = lockedOverflow;
      }

      if (modalOverlay) modalOverlay.addEventListener('click', closeModal);
      if (modalClose) modalClose.addEventListener('click', closeModal);
      document.addEventListener('keydown', function onEsc(e) {
        if (e.key === 'Escape') closeModal();
      });

      if (playBtn) {
        playBtn.addEventListener('click', function () {
          var box = playBtn.closest('.c27-support-pdp-video__media');
          if (!box) return;
          var url = box.getAttribute('data-video-url');
          if (!url) return;
          openModal(buildSupportVideoEmbed(url));
        });
      }
    });
  }

  function createController(root) {
    var component = root.getAttribute('data-c27-support-component') || '';
    if (component === 'pdp-layout') return createPdpLayoutController(root);
    if (component === 'pdp-faq') return createPdpFaqController(root);
    if (component === 'pdp-manuals') return createPdpManualsController(root);
    return {
      init: function () {},
      destroy: function () {},
      getComponent: function () {
        return component;
      },
    };
  }

  function initRoot(root) {
    if (!root || root.dataset.c27SupportInit === 'true') return;
    var ctrl = createController(root);
    controllerMap().set(root, ctrl);
    root.dataset.c27SupportInit = 'true';
    ctrl.init();
  }

  function destroyRoot(root) {
    if (!root) return;
    var ctrl = controllerMap().get(root);
    if (!ctrl) return;
    ctrl.destroy();
    controllerMap().delete(root);
    delete root.dataset.c27SupportInit;
  }

  function scan(container) {
    var roots = collectRoots(container);
    var layoutRoots = [];

    roots.forEach(function (root) {
      if (root.getAttribute('data-c27-support-component') === 'pdp-layout') {
        layoutRoots.push(root);
      }
    });

    layoutRoots.forEach(initRoot);
    rescanViewportComponents();
    initSupportVideos(container || document);
  }

  function destroy(container) {
    collectRoots(container).forEach(destroyRoot);
  }

  function refreshHeroSection(eventTarget) {
    var isHeroReload =
      eventTarget &&
      (eventTarget.classList.contains('c27-support-pdp-hero-section') ||
        (eventTarget.querySelector &&
          eventTarget.querySelector('[data-c27-support-pdp-layout-root]')));

    if (!isHeroReload) return false;

    if (pdpViewportMount) unmountPdpViewport();

    syncSpacingVars();
    updateViewportMetrics();

    var layoutRoot = document.querySelector('[data-c27-support-component="pdp-layout"]');
    if (layoutRoot) {
      if (layoutRoot.dataset.c27SupportInit === 'true') destroyRoot(layoutRoot);
      initRoot(layoutRoot);
    }

    return true;
  }

  function onSectionLoad(event) {
    var target = event.target;
    if (
      target &&
      (target.classList.contains('c27-support-pdp-hero-section') ||
        (target.querySelector &&
          target.querySelector('[data-c27-support-pdp-layout-root]')))
    ) {
      window.requestAnimationFrame(function () {
        refreshHeroSection(target);
      });
      return;
    }

    scan(target);
  }

  function onSectionUnload(event) {
    destroy(event.target);
  }

  window.__c27Support[NS] = window.__c27Support[NS] || {};
  window.__c27Support[NS].scan = scan;
  window.__c27Support[NS].destroy = destroy;
  window.__c27Support[NS].collectRoots = collectRoots;

  if (!window.__c27Support[bootKey]) {
    window.__c27Support[bootKey] = true;
    document.addEventListener('shopify:section:load', onSectionLoad);
    document.addEventListener('shopify:section:unload', onSectionUnload);

    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:select', function (event) {
        var target = event.target;
        if (!target || !target.classList.contains('c27-support-pdp-hero-section')) return;
        window.requestAnimationFrame(function () {
          syncSpacingVars();
          updateViewportMetrics();
        });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan(document);
    });
  } else {
    scan(document);
  }
})();
